
export enum AlertTypes {
    Success = 'success',
    Warning = 'warning',
    Error = 'error'
}
